import { AppDrawer, Button, IconButton, Text } from '@components'
import { BookPlus, Filter } from 'lucide-solid'
import { createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Flex } from 'styled-system/jsx'
import { useCreate } from '../../Create/state'
import Filters from '../Filters'
import { useFilters } from '../state/filter'
import { LayoutSelector } from './LayoutSelector'
import Menu from './Menu'

export function Header() {
	const [isFilterOpen, setIsFilterOpen] = createSignal(false)
	const { openCreateSetup } = useService(useCreate)()
	const { runFilters } = useService(useFilters)()

	return (
		<Flex
			justifyContent="space-between"
			alignItems="center"
			class={css({
				width: '100%',
			})}
		>
			<Menu />
			<Flex
				gap={2}
				alignItems="center"
			>
				<LayoutSelector />
				<AppDrawer
					open={isFilterOpen()}
					onOpenChange={({ open }) => setIsFilterOpen(open)}
					onExitComplete={runFilters}
					maxWidth="750px"
					title="Filter Setup"
					trigger={
						<IconButton
							variant="outline"
							colorPalette="bg"
							size="xs"
						>
							<Filter />
						</IconButton>
					}
				>
					<Filters setIsOpen={setIsFilterOpen} />
				</AppDrawer>
				<Button
					onClick={openCreateSetup}
					colorPalette="tscGreen"
					variant="solid"
					size="xs"
				>
					<BookPlus />
					<Text
						display={{
							base: 'display',
							mdDown: 'none',
						}}
						children="New"
					/>
				</Button>
			</Flex>
		</Flex>
	)
}
